<template>
	<v-tab-item
		:value="value"
		:eager="eager"
		:transition="transition"
		:reverse-transition="reverseTransition"
		:disabled="disabled"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot></slot>
	</v-tab-item>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		value: [String, Number],
		eager: Boolean,
		transition: {
			type: [Boolean, String],
			default: undefined
		},
		reverseTransition: {
			type: [Boolean, String],
			default: undefined
		},
		disabled: Boolean
	}
};
</script>
